'use client'

import { Link } from '../Link'
import { Typography } from '../Typography'
import { Container, Item } from './styles'

export interface FacilityInfoProps {
  items: {
    icon: React.ReactNode
    text: string
    truncateLines?: number
    link?: {
      href: string
      external?: boolean
      target?: string
    }
  }[]
}

export const FacilityInfo = ({ items = [] }: FacilityInfoProps) => {
  return (
    <Container>
      {items.map((item, i) => (
        <Item key={i} isLink={!!item.link}>
          {item.icon}

          {!item.link && <Typography variant="body1">{item.text}</Typography>}

          {item.link && (
            <Link
              href={item.link.href}
              target={item.link.target}
              external={item.link.external}
            >
              <Typography variant="body1">{item.text}</Typography>
            </Link>
          )}
        </Item>
      ))}
    </Container>
  )
}
